import { profileVisitorCards as TYPES } from './../action_types.wjs.jsx';

const urlFor = () =>
  $r.get_cards_api_v0_profile_visitors_path({
    subdomain_param: 'api',
    user_id: Aedu.User.current.id,
  });

const dataFor = function (cursor) {
  const data = {};
  if (cursor) {
    Object.assign(data, { cursor: cursor });
  }
  return data;
};

export function fetchProfileVisitorCards() {
  return (dispatch, getState) => {
    const { ProfileVisitorCards } = getState();

    if (ProfileVisitorCards.meta.exhausted || ProfileVisitorCards.meta.fetching)
      return;

    dispatch({ type: TYPES.FETCH_PROFILE_VISITOR_CARDS_REQUEST });

    const data = dataFor(ProfileVisitorCards.meta.cursor);

    $.getJSON(urlFor(), data).done(({ user_cards }) => {
      dispatch({
        type: TYPES.FETCH_PROFILE_VISITOR_CARDS_SUCCESS,
        profileVisitorCards: user_cards.models,
        cursor: user_cards.cursor,
        exhausted: user_cards.exhausted,
        fetching: false,
      });
    });
  };
}
